// https://github.com/ReactTraining/react-router/issues/6430#issuecomment-510266079

// TODO: Can drop this file when react-router / connected-react-router has its own hooks

import { useContext } from 'react';
import { __RouterContext as RouterContext, RouteComponentProps } from 'react-router';

export function useRouter<T extends object>() {
    return useContext(RouterContext) as RouteComponentProps<T>;
}

export function useParams<T>() {
    const { match } = useRouter();
    return match ? match.params as T : {} as T;
}
